import { Select } from '@mantine/core';
import { useFilterFormContext } from '@/pages/Statistics/StatisticsPage';

export const FormStateSelect = () => {
  const form = useFilterFormContext();

  const VALID_STATES = [
    'CANCELLED',
    'ACTIVE',
    'INACTIVE',
    'QUEUED',
    'WAITING',
  ] as const;

  type FormState = (typeof VALID_STATES)[number];

  const isValidState = (value: string | null): value is FormState => {
    return VALID_STATES.includes(value as FormState);
  };

  return (
    <Select
      label="Stav"
      value={form.values.state ?? null}
      data={[
        { value: 'CANCELLED', label: 'Storno' },
        { value: 'ACTIVE', label: 'Aktivní' },
        { value: 'INACTIVE', label: 'Neaktivní' },
        { value: 'QUEUED', label: 'V pořadníku' },
        { value: 'WAITING', label: 'Čekající' },
      ]}
      allowDeselect
      clearable
      onChange={value => {
        form.setFieldValue('state', isValidState(value) ? value : undefined);
      }}
    />
  );
};
